export const EventDescriptorSymbol = Symbol.for("@opennetwork/environment/events/descriptor");
//# sourceMappingURL=descriptor.js.map